module.exports = __webpack_public_path__ + "static/media/covid.531de49a.jpg";